<template>
    <div>
        <h1>Albums ({{ albumsCount }})</h1>   

        <div class="md-form mt-0 row">
            <input class="form-control form-control-sm ml-3 w-25" type="text" placeholder="Search" aria-label="Search" v-model="keywords">
            <button class="btn btn-primary" type="submit" v-on:click="search">Search</button>        
        </div>
        <br/>          
        <div class="overflow-auto">
            <b-pagination
                v-model="currentPage"
                :total-rows="albumsCount"
                :per-page="albumByPage"
                :limit="10"
                @change="clickCallback"
                >
            </b-pagination>
        </div>
        <div v-bind:albums="albums">
            <table class="table">
                <tr>
                    <th class="col-sm-5" @click="sort('name')">Album</th>
                    <th class="col-sm-4" @click="sort('artist')">Artist</th>
                    <th class="col-sm-3" @click="sort('updateDateTime')">Update time</th>
                </tr>
                <tr v-for="album in albums" v-bind:key="album.id">                
                    <td><router-link :to="{ name: 'album', params: { id: album.id }}">{{ album.name }}</router-link></td>                
                    <td>{{ album.artist }}</td>
                    <td>{{ album.updateDateTime | formatDate }}</td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
    
    import ApiClient from '@/tools/apiClient.js';

    let api = new ApiClient();

    export default {
        name: 'albums',            
        data: function () {
            return {
                albums: [],
                albumsCount: 0,                
                pageCount: 1,   
                albumByPage: 50,
                currentPage: 1,
                keywords: '',
                orderByField: "name",
                orderBy: "ascending"         
            }
        },

        created: async function () {
            this.keywords = '';
            this.albumsCount = await api.getAlbumsCountAsync();
            this.pageCount = this.albumsCount / this.albumByPage;
            
            this.albums = await api.getAlbumsAsync(this.keywords, this.orderByField, this.orderBy, 0, this.albumByPage);
        },

        methods: {
            clickCallback: async function(page) {                
                var offset = (page - 1) * this.albumByPage;              
                this.albums = await api.getAlbumsAsync(this.keywords, this.orderByField, this.orderBy, offset, this.albumByPage);
            },

            search: async function() {
                var offset = 0;
                this.currentPage = 1;
                                                    
                this.albums = await api.getAlbumsAsync(this.keywords, this.orderByField, this.orderBy, offset, this.albumByPage);
                
                if(this.keywords == '')
                    this.albumsCount = await api.getAlbumsCountAsync();
                else
                    this.albumsCount = this.albums.length;

                this.currentPage = 1;                
                this.pageCount = this.albumsCount / this.albumByPage;                
            },

            sort: async function(field) {                
                if(field === this.orderByField) {
                    this.orderBy = this.orderBy === 'ascending' ? 'descending' : 'ascending';
                }

                this.orderByField = field;

                await this.search();
            }
        }
    }
</script>
